import { render, staticRenderFns } from "./CustomerCatalogs.vue?vue&type=template&id=52c67614&"
import script from "./CustomerCatalogs.vue?vue&type=script&lang=js&"
export * from "./CustomerCatalogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports